import { IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import { buildCanonicalUrl } from "@/utils/seo/canonical";

const socialLinks = [
  { title: IconTypeEnum.Vk, link: `https://vk.com/lunaro_ru` },
  { title: IconTypeEnum.Ok, link: `https://ok.ru/lunaro` },
  { title: IconTypeEnum.Tg, link: `https://t.me/lunaroru` },
  { title: IconTypeEnum.Dz, link: `https://zen.yandex.ru/lunaro` },
];

const knowledge = {
  title: `Знания`,
  items: [
    { title: `Блог Лунаро`, link: `/lifestyles` },
    { title: `Курсы Таро`, link: `/category/obuchenie-taro` },
    { title: `Гид по Таро Уэйта`, link: `/articles/gid-po-kartam-taro` },
    { title: `Гид по Манаре`, link: `/articles/gid-po-kartam-taro/manara` },
    { title: `Гид по Ошо Дзен`, link: `/articles/gid-po-kartam-taro/osho-dzen` },
    { title: `Гид по Ленорман`, link: `/articles/gid-po-kartam-taro/lenorman` },
    { title: `Гадание на картах Таро`, link: `/category/gadanie/na-kartah-taro` },
    { title: `Гид по знакам зодиака`, link: `/gidy/zodiak` },
    { title: `Книга перемен И Цзин`, link: `/gidy/kniga-peremen` },
    { title: `Гороскопы`, link: `/goroskop` },
  ],
};

const aboutUs = {
  title: `О нас`,
  items: [
    { title: `О сервисе`, link: `/about` },
    { title: `Гарантии`, link: `/guarantees` },
    { title: `Цены`, link: `/prices` },
    { title: `Отзывы`, link: `/otzyvy` },
    { title: `Мы в СМИ`, link: `/smi` },
  ],
};

export const PROMO_CODES_LINK = `/profile/promo-codes`;

const benefits = {
  title: `Польза`,
  items: [
    { title: `Бонусы`, link: `/bonuses` },
    { title: `Промокоды`, link: PROMO_CODES_LINK },
    { title: `Подарочные сертификаты`, link: `/certificate` },
    { title: `Партнёрская программа`, link: `https://partner.lunaro.ru/` },
  ],
};

const paymentInfo = {
  title: `Способы оплаты`,
  items: [
    { iconType: IconTypeEnum.PayMastercard, iconSize: IconSizeEnum.Size28, title: `Mastercard` },
    { iconType: IconTypeEnum.PayVisa, iconSize: IconSizeEnum.Size32, title: `Visa` },
    { iconType: IconTypeEnum.PayMir, iconSize: IconSizeEnum.Size32, title: `Мир` },
    { iconType: IconTypeEnum.PayYandex, iconSize: IconSizeEnum.Size36, title: `Yandex Pay` },
  ],
};

const beExpert = {
  title: `Ищем экспертов в эзотерике`,
  anchor: {
    title: `hello@lunaro.ru`,
    link: `mailto:hello@lunaro.ru`,
  },
  description: `Напишите нам о\u00a0себе и\u00a0своём опыте`,
  details: { title: `Узнать подробнее`, link: `/ekspertam` },
};

const bottomData = {
  agreement: {
    title: `Пользовательское соглашение`,
    name: `Пользовательским соглашением`,
    link: `/user-agreement`,
  },
  confidence: {
    title: `Политика конфиденциальности`,
    name: `Политикой конфиденциальности`,
    link: `/privacy-policy`,
  },
  cookie: {
    title: `Политика cookie`,
    name: `Политикой cookie`,
    link: `/cookie-policy`,
  },
  agency: {
    title: `Агентское соглашение на поиск эксперта и организацию консультации`,
    name: `Агентским соглашением на\u00a0поиск эксперта и\u00a0организацию консультации`,
    link: `/consultation-agreement`,
  },
  referral: {
    title: `Правила реферальной программы`,
    name: `Правилами реферальной программы`,
    link: `/referral.pdf`,
  },
  serviceRules: {
    title: `Правила оказания услуг`,
    name: `Правилами оказания услуг`,
    link: `/consultation-terms`,
  },
  llms: {
    title: `lunaro.ru LLMs.txt`,
    name: `Документация для LLM и AI-агентов`,
    // Абсолютный адрес: относительный ломается в архивных снимках и при рерайтах прокси/CDN.
    link: buildCanonicalUrl("/llms.txt"),
  },
  copyright: `© Lunaro, ${new Date().getFullYear()}`,
};

export const FOOTER_DATA = {
  logoSubtitle: `Онлайн-консультации с\u00a0экспертами в\u00a0области эзотерики`,
  socialLinks,
  menus: {
    aboutUs,
    benefits,
    paymentInfo,
    knowledge,
  },
  beExpert,
  bottomData,
};
